<template>
  <FilterSearch
    :name="`${configData?.Category}-search`"
    :placeholder="configData?.Placeholder"
  />

  <FilterButtonRow
    @more-filters-drawer="() => (showMoreFiltersDrawer = true)"
    @sorting-drawer="() => (showSortingDrawer = true)"
  />

  <FilterMoreFiltersDrawer
    v-model="showMoreFiltersDrawer"
    title="Filter"
    :description="configData?.DrawerDescription ?? ''"
    :number-of-results="filterStore.numberOfFilteredProducts"
  />

  <FilterSortingDrawer
    v-model="showSortingDrawer"
    title="Sortering"
    description="Vad är viktigast för dig?"
  />
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    Placeholder?: string;
    Category?: string;
    DrawerDescription?: string;
    DefaultPlanId?: number;
    DefaultDownPayment?: number;
  };
}

defineProps<Props>();

const filterStore = useFilterStore();

const showMoreFiltersDrawer = ref(false);
const showSortingDrawer = ref(false);
</script>
